import React from 'react'
import Scrollchor from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'So hat Ihre Gemeinde abgestimmt',
    fr: 'Voici ce que votre commune a voté'
  },
  lead: {
    de: (
      <>
        Erfahren Sie, wie man in Ihrer Gemeinde entschieden hat – auf nationaler, kantonaler und kommunaler Ebene. 
        Wie der Service funktioniert,{' '}
        <Scrollchor to='#methodik'>lesen Sie hier</Scrollchor>.
      </>
    ),
    fr: (
      <>
        Découvrez comment votre commune a voté, tant au niveau fédéral, cantonal que communal. 
        Le mode de fonctionnement de ce service est{' '}
        <Scrollchor to='#methodik'>expliqué ici</Scrollchor>.
      </>
    )
  },
  feedback: {
    title: {
      de: 'Wie wars?',
      fr: 'Comment jugez-vous ce contenu?'
    },
    questions: {
      de: [
        'Funktionierte die technische Umsetzung?',
        'Wie beurteilen Sie die Textqualität?',
        'Wie beurteilen Sie den Nutzen dieses Textes?'
      ],
      fr: [
        'La mise en oeuvre technique a-t-elle fonctionné?',
        'Comment évaluez-vous la qualité du texte?',
        'Comment évaluez-vous l’utilité du texte?'
      ]
    }
  },
  methodology: {
    title: {
      de: <>Wie dieser Text geschrieben wurde</>,
      fr: <>Comment ce texte est-il écrit?</>
    },
    text: {
      de: (
        <>
          <p>
          Die Redaktion Tamedia hat einen regelbasierten Algorithmus entworfen, der die rund 4500 deutschen und französischen Abstimmmungstexte für 
          über 2200 Gemeinden automatisch generiert. Die dafür benötigten Daten werden vom Bundesamt für Statistik bezogen. 
          Die Texte für kommunale Abstimmungen, falls vorhanden, werden von den Redaktionen selbst verfasst.  
          </p>
          <p>Die Stimmbeteiligung zeigt die <i>durchschnittliche</i> Beteiligung bei den eidgenössischen Vorlagen für die jeweilige Gemeinde, 
          den dazugehörigen Kanton und für die Gesamtschweiz.</p>
        </>
      ),
      fr: (
        <>
          <p>
          La rédaction de Tamedia a développé un algorithme permettant de générer ce texte. Les parties concernant les votes 
          communaux font exception et sont rédigés par la rédaction. Les quelque 4500 textes et tableaux en français 
          et en allemand disponibles ici sont basés sur les résultats des votes des plus de 2200 communes de Suisse. 
          Les données sont fournies par l'Office fédéral de la statistique.</p>
          <p>Le taux de participation indique la participation <i>moyenne</i> de la population aux scrutins fédéraux, cantonaux et communaux.</p>
        </>
      )
    }
  },
  credits: {
    de: [
      [
        'Programmierung',
        'Mathieu Rudaz (Frontend) und Yvan Da Silva (Backend)'
      ],
      [
        'Datenaufbereitung',
        'Mathias Born, basierend auf Daten des Bundesamts für Statistik'
      ],
      [
        'Texte',
        "Timo Grossenbacher, Lucie Monnat (<a href='https://interactif.24heures.ch/2020/atm-vote-2020-11/'>Französisch</a>) und die Tamedia-Redaktionen (kommunale Texte)"
      ],
      ['Bild', 'Viviane Futterknecht'],
      ['Projektleitung', 'Timo Grossenbacher']
    ],
    fr: [
      ['Programmation', 'Mathieu Rudaz (Frontend) et Yvan Da Silva (Backend)'],
      [
        'Préparation des données',
        'Mathias Born, sur la base des données de l’Office fédéral de la statistique'
      ],
      [
        'Textes',
        "Lucie Monnat (briques de texte en français), Timo Grossenbacher (<a href='https://interaktiv.tagesanzeiger.ch/2020/atm-vote-2020-11/'>allemand</a>) et les rédactions de Tamedia (textes communales)"
      ],
      ['Illustration', 'Viviane Futterknecht'],
      ['Gestion du projet', 'Timo Grossenbacher']
    ]
  }
}

export default LOCALES
